import { Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import { i18nResolver } from 'src/app/core/resolvers';

export const priceCalculatorRoutes: Routes = [
  {
    path: 'price-calculator/:type',
    title: 'WEB_REGISTATION_AAA',
    resolve: {
      agorai18n: i18nResolver,
    },
    loadComponent: () =>
      import('./pages/price-calculator.component').then(
        (m) => m.PriceCalculatorComponent
      ),
    data: { navigationRoute: ROUTE_NAMES.PRICE_CALCULATOR },
  },
];
